module.exports = __webpack_public_path__ + "img/ic_stop.c1673092.svg";